/* ==========================================================================
   ButtonRxjs > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'BUTTON::DESTROY';
const DISABLE = 'BUTTON::DISABLE';
const DISPLAY = 'BUTTON::DISPLAY';
const ENABLE = 'BUTTON::ENABLE';
const HIDE = 'BUTTON::HIDE';

const SET_CONTENT = 'BUTTON::SET_CONTENT';
const SET_ICON = 'BUTTON::SET_ICON';

const TOGGLE_LOADING = 'BUTTON::TOGGLE_LOADING';

/* Actions */
const destroy = () => ({ type: DESTROY });
const disable = () => ({ type: DISABLE });
const display = () => ({ type: DISPLAY });
const enable = () => ({ type: ENABLE });
const hide = () => ({ type: HIDE });

const setContent = payload => ({ type: SET_CONTENT, payload });
const setIcon = payload => ({ type: SET_ICON, payload });

const toggleLoading = () => ({ type: TOGGLE_LOADING });

/* Exports */
module.exports = {
    types: {
        DESTROY,
        DISABLE,
        DISPLAY,
        ENABLE,
        HIDE,
        SET_CONTENT,
        SET_ICON,
        TOGGLE_LOADING
    },
    actions: {
        destroy,
        disable,
        display,
        enable,
        hide,
        setContent,
        setIcon,
        toggleLoading
    }
};
